// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"46320ca5","453":"f41adcd0","667":"8d5c94f0","946":"4851de53"}[chunkId] + ".chunk.js";
};